import React, { useContext } from "react";
import { FarmerContext } from "./FarmerContext";
import { Link } from "react-router-dom";
import Pagination from "../../Pagination";
import "./farmerHotels.css"
import Spinner from "../../Spinner";
export default function FarmerHotels() {
;
  const {availableHotels, formik, setRelToDel, newHotelsData, farmerHotels, postsPerPage, currentPage, paginate } = useContext(FarmerContext)
  const shouldPaginate = farmerHotels.length > 4
  const displayedHotels = shouldPaginate ? newHotelsData : farmerHotels
  const farmerHotelName = availableHotels.length > 0 ? availableHotels.map((hotel) => hotel.name) : null
  const handleDeleteClick=(hotelName)=>{
    formik.setFieldValue("name",hotelName)
    setRelToDel(true)
  }

  return (
    <div className=" max-w-full min-w-fit mt-4 mb-8">
      <div>
        <div>
          <Link to="/FarmerDash/communicate/hotelOwners">Communicate</Link>
        </div>
      </div>
      <p className="font-bold">HOTELS</p>
      <div>
        {displayedHotels?.length > 0 ?
        <div className="hotel-grid mt-4">
        {displayedHotels.map((hotel,index) => (          
          <div key={index} className="hotel-card space-x-2 flex mt-10">        
           <form onSubmit={formik.handleSubmit} className="">
             <button type="submit" onClick={()=>handleDeleteClick(hotel.name)} className=" bg-red-500 rounded-lg ml-2 delete-button mt-0">
             DELETE
             </button>
            </form>
            <div className="hotel-container">
              <img
                src={hotel.image_url}
                alt={hotel.name}
                className="hotel-image"
                // style={{ objectFit: "cover", width: "100%", height: "100%" }}
                onError={(e) => e.target.style.display = 'none'}
              />
              <div className="data-overlay" key={index} >
                <p className="text-white italic">{hotel.name}</p>
                <p className="text-white italic">{hotel.email}</p>
                <h4 className="text-white italic">{hotel.location}</h4>
                <p className="text-white italic">{hotel.goods_type}</p>
              </div>       
                     
            </div>
          </div>
        ))}
      </div>
        : <p>Sorry seems you do not have hotel a  want to add</p>}
        </div>
      {shouldPaginate ? <Pagination postsPerPage={postsPerPage} totalPosts={farmerHotels.length} currentPage={currentPage} paginate={paginate} /> : null}
      {availableHotels.length > 0 ?
        <form onSubmit={formik.handleSubmit}>
          <label htmlFor="name">Select hotel to add</label>
          <select onChange={formik.handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            value={formik.name} name="name" id="name"
          >           <option>Select a hotel</option>
            {farmerHotelName.map((farmer, index) => (
              <option value={farmer} key={index}>{farmer}</option>
            ))}
          </select>
          <button type="submit" className="bg-blue-500 rounded-lg text-white disabled:opacity-50" disabled={formik.isSubmitting || !formik.isValid}
          //  onClick={setRelToDelete(false)}
          >Send request</button>
        </form>
        : null}
    </div>
  )
}


